import React from "react";
import "./App.css"; // Global styles if any remaining
import Layout from "./components/Layout";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import SitesSection from "./components/SitesSection";

function App() {
  return (
    <Layout>
      <Hero />
      <AboutSection />
      <SitesSection />
    </Layout>
  );
}

export default App;
